<template>
  <div class="vue-codemirror">
    <label>
      <span v-if="label">{{ label }}</span>
      <textarea
        ref="textareaEditor"
        :name="name"
        :placeholder="placeholder"
        rows="8"
        cols="80"
      ></textarea>
    </label>
  </div>
</template>

<script>
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/edit/closetag.js';
import 'codemirror/addon/edit/closebrackets.js';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/theme/base16-light.css';

export default {
  name: 'CodeFormTextEditor',
  data() {
    return {
      content: '',
      codemirror: null,
      codemirrorInstance: null,
    };
  },
  props: {
    code: String,
    label: String,
    modeType: {
      type: String,
      default: 'htmlmixed',
    },
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default:
        'Use a div element with the .container class to wrap the content',
    },
  },
  watch: {
    code(newVal) {
      this.handleCodeChange(newVal);
    },
  },
  methods: {
    initialize() {
      const options = {
        tabSize: 4,
        mode: this.modeType,
        theme: 'base16-light',
        lineNumbers: true,
        line: true,
        autoCloseTags: true,
        autoCloseBrackets: true,
        autoRefresh: true, // as not loading until clicked
      };
      const codemirrorOptions = Object.assign({}, options);
      this.codemirror = CodeMirror.fromTextArea(
        this.$refs.textareaEditor,
        codemirrorOptions
      );
      this.codemirrorInstance = this.codemirror;
      this.codemirrorInstance.setValue(this.code || this.content);
      this.codemirrorInstance.on('change', cm => {
        this.content = cm.getValue();
        if (this.$emit) {
          this.$emit('input', {
            key: this.name,
            value: this.content,
          });
        }
      });
      this.$emit('ready', this.codemirror);

      // prevents funky dynamic rendering
      this.refresh();
    },
    refresh() {
      this.$nextTick(() => {
        this.codemirrorInstance.refresh();
      });
    },
    destroy() {
      // garbage cleanup
      const element = this.codemirrorInstance.doc.cm.getWrapperElement();
      element && element.remove && element.remove();
    },
    handleCodeChange(newVal) {
      const cm_value = this.codemirrorInstance.getValue();
      if (newVal !== cm_value) {
        const scrollInfo = this.codemirrorInstance.getScrollInfo();
        this.codemirrorInstance.setValue(newVal);
        this.content = newVal;
        this.codemirrorInstance.scrollTo(scrollInfo.left, scrollInfo.top);
      }
    },
  },
  mounted() {
    this.initialize();
  },
  beforeDestroy() {
    this.destroy();
  },
};
</script>
<style>
.CodeMirror {
  margin: 0.5rem 0 0.5rem;
}
.cm-s-base16-light.CodeMirror {
  background: #fff;
}
.cm-s-base16-light .CodeMirror-gutters {
  background: #314151;
  border-right: 2px solid #314151;
}
</style>
